import React from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { filter, get, round } from "lodash";
import {
  formatNumberOnDashBoard,
  getLocalstorage,
  isValidArray,
  setLocalstorage
} from "../../../helper";
import { connect } from "react-redux";
import { STATUS, MIS_ACTION } from "../../../constant";
import NoDataFound from "../../../component/NoDataFound";
import AppliedFilters from "../AppliedFilterDisplay";
import { getDistrictDepartmentByParentIds } from "../../../actions/mis.action";
import { bindActionCreators } from "redux";
import {
  fetchProjectReport,
  fetchStateProjectReport,
  fetchSelectedStateValue,
  fetchSelectedMonitoringValue,
  clearStateProjectReport,
  clearSelectedStateValue,
  clearSelectedMonitringValue,
  fetchMonitoringValue
} from "../../../actions/mis.action";

class StateSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stateList: []
    };
  }

  removeAllFilters = () => {
    const { fetchProjectReport } = this.props;
    let appliedFilters = setLocalstorage("projectSummaryFilters", null);
    fetchProjectReport(appliedFilters);
  };

  componentDidMount() {
    const {
      getRecipientMinistryStateAction,
      fetchStateProjectReport,
      clearSelectedStateValue
    } = this.props;
    // fetchStateProjectReport()
    fetch(fetchStateProjectReport())
      .then(response => response.json())
      .then(data => {
        // Handle the fetched data, e.g., update component state
        // this.setState({ data });
      })
      .catch(error => {});
    const state = {
      label: "",
      name: "",
      optionName: "",
      value: ""
    };
    clearSelectedStateValue(state);
    localStorage.removeItem("monitoring");
    localStorage.removeItem("filtersList");
  }

  render() {
    const {
      misDataReport,
      misFlatFileStatus,
      stateProjectsList,
      selectedState,
      fetchSelectedMonitoringValue,
      clearStateProjectReport,
      fetchSelectedStateValue,
      clearSelectedStateValue,
      clearSelectedMonitringValue,
      fetchMonitoringValue
    } = this.props;

    let selectedMonitoring;
    if (
      JSON.parse(localStorage.getItem("monitoring")) == null ||
      JSON.parse(localStorage.getItem("monitoring")) == undefined
    ) {
      selectedMonitoring = {
        name: "",
        label: "Select Monitoring",
        value: "",
        optionName: "Select Monitoring Flag"
      };
    } else {
      selectedMonitoring = JSON.parse(localStorage.getItem("monitoring"));
    }
    let clearStatevariable;
    if (selectedState.value == null || selectedState.value == undefined) {
      clearStatevariable = {
        name: "",
        label: "Select Monitoring",
        value: "",
        optionName: "Select Monitoring Flag"
      };
    } else {
      clearStatevariable = {
        name: selectedState.name,
        label: selectedState.label,
        value: selectedState.value,
        optionName: selectedState.name
      };
    }

    const postStateFilterData = async filterData => {
      const { clearStateYellowChips } = this.props;

      clearSelectedStateValue(selectedState.value);
      const arrayString = localStorage.getItem("filtersList");
      const myArray = JSON.parse(arrayString);
      const optionNameToRemove = "SelectState"; // Adjust as needed
      const filteredArray = myArray.filter(
        item => item.optionName !== optionNameToRemove
      );

      const updatedArrayString = JSON.stringify(filteredArray);
      localStorage.setItem("filtersList", updatedArrayString);
      localStorage.removeItem("selectedState");
      //localStorage.removeItem('filtersList')
      clearStateProjectReport([], selectedMonitoring);
      clearStateYellowChips();
    };

    const postMonitringFilterData = async filterData => {
      const { clearStateYellowChips } = this.props;

      clearSelectedMonitringValue(selectedMonitoring.value);
      const arrayString = localStorage.getItem("filtersList");
      const myArray = JSON.parse(arrayString);
      // Remove the element with optionName "Monitoring"
      const optionNameToRemove = "Monitoring";
      const filteredArray = myArray.filter(
        item => item.optionName !== optionNameToRemove
      );
      localStorage.setItem("filtersList", JSON.stringify(filteredArray));

      localStorage.removeItem("monitoring");
      //localStorage.removeItem('filtersList')
      clearStateProjectReport(selectedState, [], 0);
      clearStateYellowChips();
      //localStorage.removeItem("selectedState")
    };

    const handleClearAll = () => {
      const { clearStateYellowChips } = this.props;
      localStorage.removeItem("filtersList");
      localStorage.removeItem("selectedState");
      fetch(clearStateProjectReport([], [], 0))
        .then(response => response.json())
        .then(data => {
          // Handle the fetched data, e.g., update component state
          // this.setState({ data });
        })
        .catch(error => {
          // Handle errors
        });
      localStorage.removeItem("monitoring");
      clearSelectedStateValue(selectedState.value);
      clearStateYellowChips();
    };
    const filterList = JSON.parse(localStorage.getItem("filtersList"));
    const stateselect = JSON.parse(localStorage.getItem("selectedState"));

    let percentTotalProjectWithIssues;
    let percentTotalProjectWithOutIssues;
    if (
      stateProjectsList.data !== null &&
      stateProjectsList.data !== undefined
    ) {
      percentTotalProjectWithIssues =
        (stateProjectsList.data.totalProjectWithIssues /
          stateProjectsList.data.total) *
        100;

      percentTotalProjectWithOutIssues =
        (stateProjectsList.data.totalProjectWithOutIssues /
          stateProjectsList.data.total) *
        100;
    }
    return (
      <React.Fragment>
        <div
          className="row"
          style={{ paddingLeft: "14px", paddingBottom: "15px" }}
        >
          {isValidArray(filterList)
            ? filterList
                .filter(filterData => {
                  return !["", ""].includes(filterData.value);
                })
                .map(filterData => {
                  return (
                    <div
                      data-test="applied-filter-on-projects-list"
                      className="applied-state-filter row-state"
                      colspan="2"
                    >
                      {filterData.label}
                      {filterData.optionName === "SelectState" ? (
                        <span
                          data-test="close-button-of-project-list-applied-filter"
                          className="close"
                          onClick={e => {
                            postStateFilterData(filterData);
                          }}
                        >
                          X
                          {/* <button className="read-more-button">X</button> */}
                        </span>
                      ) : (
                        <span
                          data-test="close-button-of-project-list-applied-filter"
                          className="close"
                          onClick={e => {
                            postMonitringFilterData(filterData);
                          }}
                        >
                          X
                          {/* <button className="read-more-button">X</button> */}
                        </span>
                      )}
                    </div>
                  );
                })
            : ""}

          {stateselect !== null &&
            stateselect !== undefined &&
            stateselect.value.length !== 0 &&
            selectedMonitoring !== null &&
            selectedMonitoring !== undefined &&
            selectedMonitoring.value.length !== 0 && (
              <div colspan="2">
                <button className="row-state-clear" onClick={handleClearAll}>
                  Clear All
                </button>
              </div>
            )}
        </div>

        <Table
          table="1"
          striped
          size="sm"
          className="state-project-list table table-striped"
        >
          <thead>
            <tr style={{ boxShadow: "0 4px 3px 0 rgb(213, 218, 223)" }}>
              <th className="state-min-column" colspan="6" rowspan="2">
                Sponsoring Ministry
              </th>

              <th className="state-column-project state-border" colspan="6">
                Projects
              </th>

              <th className="state-column-project" colspan="2">
                Issues
              </th>
            </tr>
            <tr>
              {/* <th colspan="6" className="state-column" rowspan="2" >Sponsoring Ministry</th> */}
              <th colspan="2" className="state-column-head">
                With Issues
              </th>
              <th colspan="2" className="state-column-head">
                Without Issues
              </th>
              <th colspan="2" className="state-column-head state-border">
                Total
              </th>
              <th colspan="2" className="state-column-head">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {get(stateProjectsList, "data") !== null &&
              get(stateProjectsList, "data") !== undefined && (
                <tr style={{ boxShadow: "0 4px 3px 0 rgb(213, 218, 223)" }}>
                  <td className="state-grand-column " colspan="6">
                    <b>Grand Total</b>
                  </td>
                  <td className="state-column-footer" colspan="2">
                    <OverlayTrigger
                      placement="bottom-start"
                      key="bottom"
                      overlay={
                        <Tooltip
                          id="tooltip-bottom"
                          className="mis-tooltip"
                          placement="bottom-start"
                        >
                          {stateProjectsList.data.total !== 0
                            ? round(percentTotalProjectWithIssues)
                            : 0}
                          %
                        </Tooltip>
                      }
                    >
                      <div>{stateProjectsList.data.totalProjectWithIssues}</div>
                    </OverlayTrigger>
                  </td>
                  <td className="state-column-footer" colspan="2">
                    <OverlayTrigger
                      placement="bottom-start"
                      key="bottom"
                      overlay={
                        <Tooltip
                          id="tooltip-bottom"
                          className="mis-tooltip"
                          placement="bottom-start"
                        >
                          {stateProjectsList.data.total !== 0
                            ? round(percentTotalProjectWithOutIssues)
                            : 0}
                          %
                        </Tooltip>
                      }
                    >
                      <div>
                        {stateProjectsList.data.totalProjectWithOutIssues}
                      </div>
                    </OverlayTrigger>
                  </td>
                  <td className="state-column-footer state-border" colspan="2">
                    {stateProjectsList.data.total}
                  </td>
                  <td className="state-column-footer" colspan="2">
                    {stateProjectsList.data.totalIssues}
                  </td>
                </tr>
              )}
            {misFlatFileStatus === STATUS.LOADING ? (
              <tr>
                <td colSpan="14">
                  <NoDataFound />
                </td>
              </tr>
            ) : isValidArray(get(stateProjectsList.data, "listDTO")) ? (
              stateProjectsList.data.listDTO.map((stateProject, index) => {
                const issuePercentage =
                  (stateProject.projectWithIssuesCount /
                    stateProject.projectCount) *
                  100;
                const withoutIssuesPercentage =
                  (stateProject.projectWithoutIssuesCount /
                    stateProject.projectCount) *
                  100;

                return (
                  <tr>
                    <td colspan="6" className="state-ministry-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {stateProject.sponsoredBy}
                          </Tooltip>
                        }
                      >
                        <div>{stateProject.sponsoredBy}</div>
                      </OverlayTrigger>
                    </td>
                    <td colspan="2" className="state-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {stateProject.projectCount !== 0
                              ? round(issuePercentage)
                              : 0}
                            %
                          </Tooltip>
                        }
                      >
                        <div>{stateProject.projectWithIssuesCount}</div>
                      </OverlayTrigger>
                    </td>
                    <td colspan="2" className="state-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {stateProject.projectCount !== 0
                              ? round(withoutIssuesPercentage)
                              : 0}
                            %
                          </Tooltip>
                        }
                      >
                        <div>{stateProject.projectWithoutIssuesCount}</div>
                      </OverlayTrigger>
                    </td>
                    <td colspan="2" className="state-column">
                      {stateProject.projectCount}
                    </td>
                    <td colspan="2" className="state-column">
                      {stateProject.totalIssuesCount}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="14">
                  <NoDataFound />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    misFlatFileStatus: state.misReducer.misFlatFileStatus,
    stateProjectsList: state.misReducer.stateProjectsList,
    selectedState: state.misReducer.selectedState,
    selectedMonitoring: state.misReducer.selectedMonitoring
    //misData: state.stateProjectReport.data
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      // getDistrictDepartmentByParentIds,
      // fetchProjectReport,
      fetchStateProjectReport,
      fetchSelectedStateValue,
      clearStateProjectReport,
      clearSelectedStateValue,
      clearSelectedMonitringValue,
      fetchMonitoringValue
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StateSummary);
